var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-page-wrapper',{attrs:{"title":"Буферные аккаунты","settings-title":"Буферные аккаунты","error-text":"Список аккаунтов не загружен","columns":_vm.columns,"filters":_vm.filters,"table-options":_vm.table,"create-form":_vm.createPersonalRateForm,"is-need-create-btn":_vm.showModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }